import { Calendar, Info, Package, UsersIcon } from "lucide-react";
import { Card, CardContent } from "../../../ui/card";

type MiqaatRotationDetails = {
    requireRaza?: boolean;
    id: string | number;
    miqaatName: string;
    miqaatCode: string;
    rotationName: string;
    rotationId: string;
    arrivalDate: string;
    departureDate: string;
    availableQuota: number;
    totalQuota: number;
};

type Props = {
    rotationDetails: MiqaatRotationDetails | null;
};

const RotationDetailsCard = ({ rotationDetails }: Props) => {
    if (!rotationDetails) return null;

    return (
        <Card className="mb-6 bg-gradient-to-r from-purple-100 via-blue-100 to-purple-100 border-2 border-purple-200/50 shadow-md rounded-2xl">
            <CardContent className="p-4 md:p-6">
                <div className="flex flex-col md:flex-row md:items-center gap-4">
                    <div className="flex-1 space-y-3">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

                            {/* Miqaat & Rotation */}
                            <div className="flex justify-between items-center">
                                <div className="flex flex-wrap items-center gap-2">
                                    <div className="flex items-center gap-2 px-3 py-2 rounded-full bg-gradient-to-r from-purple-500 to-purple-500 shadow-lg">
                                        <Package className="w-4 h-4 text-white" />
                                        <span className="text-white font-semibold text-sm">
                                            {rotationDetails.miqaatCode}
                                        </span>
                                        <span className="text-white">-</span>
                                        <span className="text-white font-semibold">
                                            {rotationDetails.rotationName}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Raza */}
                            <div className="flex items-center gap-2 text-sm">
                                <div className="w-10 h-10 rounded-full bg-white/80 flex items-center justify-center">
                                    <Info className="w-5 h-5 text-purple-600" />
                                </div>
                                <div>
                                    <div className="text-gray-500 text-xs">Raza</div>
                                    <span className="font-semibold text-gray-900">
                                        {rotationDetails.requireRaza ? "Yes" : "No"}
                                    </span>
                                </div>
                            </div>

                            {/* Date */}
                            <div className="flex items-center gap-2 text-sm">
                                <div className="w-10 h-10 rounded-full bg-white/80 flex items-center justify-center">
                                    <Calendar className="w-5 h-5 text-purple-600" />
                                </div>
                                <div>
                                    <div className="text-gray-500 text-xs">Date</div>
                                    <span className="font-semibold text-gray-900">
                                        {rotationDetails.arrivalDate?.split("T")[0]}
                                    </span>
                                </div>
                            </div>

                            {/* Quota */}
                            <div className="flex items-center gap-2 text-sm">
                                <div className="w-10 h-10 rounded-full bg-white/80 flex items-center justify-center">
                                    <UsersIcon className="w-5 h-5 text-purple-600" />
                                </div>
                                <div>
                                    <div className="text-gray-500 text-xs">Available Quota</div>
                                    <span className="font-semibold text-gray-900">
                                        {rotationDetails.availableQuota}/{rotationDetails.totalQuota}
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

export default RotationDetailsCard;